import { SectionLabel } from '../ui/SectionLabel';
import { PORTAL_BASE_PATH } from '../../lib/portal';

export function Portal() {
  return (
    <section className="section portal-section" id="portal" aria-labelledby="portal-title">
      <div className="wrap portal-inner">
        <div className="portal-copy" data-reveal>
          <SectionLabel>Portal</SectionLabel>
          <h2 id="portal-title">See the engineering.</h2>
          <p>
            ADCS builds live environments for exploring simulations, control behaviour,
            telemetry interfaces and mission software. They turn engineering results
            into something clients can inspect, exercise and discuss together.
          </p>
        </div>
        <p className="portal-actions" data-reveal>
          <a className="btn btn-quiet" href={`${PORTAL_BASE_PATH}/`}>
            Client portal
          </a>
        </p>
      </div>
    </section>
  );
}
